// Scroll Reveal Utility
// Observes elements with .reveal, .reveal-left, .reveal-right, .reveal-scale
// and adds .revealed when they enter the viewport

export function initScrollReveal() {
  const selectors = '.reveal, .reveal-left, .reveal-right, .reveal-scale';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          // Once revealed, stop observing
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  const observe = () => {
    document.querySelectorAll(selectors).forEach((el) => {
      observer.observe(el);
    });
  };

  // Initial run
  observe();

  // Also observe after a short delay for dynamically rendered elements
  setTimeout(observe, 300);

  return observer;
}
